export default function Send({
  color = 'white',
  width = '17',
  height = '16',
  style,
}) {
  return (
    <svg
      className={style}
      width={width}
      height={height}
      viewBox='0 0 17 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2987_19977)'>
        <path
          d='M5.43313 4.21344L11.0931 2.32677C13.6331 1.4801 15.0131 2.86677 14.1731 5.40677L12.2865 11.0668C11.0198 14.8734 8.93979 14.8734 7.67313 11.0668L7.11312 9.38677L5.43313 8.82677C1.62646 7.5601 1.62646 5.48677 5.43313 4.21344Z'
          stroke={color}
          strokeWidth='1.2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          opacity='0.34'
          d='M7.23975 9.10036L9.62641 6.70703'
          stroke={color}
          strokeWidth='1.2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_2987_19977'>
          <rect
            width='16'
            height='16'
            fill={color}
            transform='translate(0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
